import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../api";
import { ADMIN_PATH } from "../../config";

const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!username.trim() || !password.trim()) {
            setError("Username and password are required.");
            return;
        }
        setLoading(true);
        setError("");
        const data = await api.login(username, password);
        if (data.token) {
            localStorage.setItem("token", data.token);
            navigate(ADMIN_PATH);
        } else {
            setError("Invalid credentials.");
        }
        setLoading(false);
    };

    return (
        <div className="min-h-screen bg-(--bg-main) flex items-center justify-center">
            <div className="w-full max-w-sm">
                <h1 className="font-is text-4xl mb-8">admin.</h1>
                <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                    <input
                        type="text"
                        placeholder="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        className="font-inter text-sm px-4 py-3 rounded-xl border border-neutral-200 bg-white/50 outline-none focus:border-[#F4611D] transition-colors"
                    />
                    <input
                        type="password"
                        placeholder="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="font-inter text-sm px-4 py-3 rounded-xl border border-neutral-200 bg-white/50 outline-none focus:border-[#F4611D] transition-colors"
                    />
                    {error && <p className="font-inter text-xs text-red-500">{error}</p>}
                    <button
                        type="submit"
                        disabled={loading}
                        className="font-inter text-sm px-4 py-3 rounded-xl bg-[#F4611D] text-white hover:bg-[#d94e0f] transition-colors disabled:opacity-50 cursor-pointer"
                    >
                        {loading ? "signing in..." : "sign in"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;
